export default {
    UsuarioPorCpf: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "usuario-por-cpf"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/UsuarioPorCpf.js
// module id = yR18
// module chunks = 13